import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { resolveShortLink } from 'src/services/api/shortLink';

const ShortLink = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    resolveShortLink(code ?? '')
      .then(({ hash }) => {
        if (active) navigate(`/settlement/${hash}`, { replace: true });
      })
      .catch(() => {
        if (active) navigate('/404', { replace: true });
      });
    return () => {
      active = false;
    };
  }, [code, navigate]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress />
    </Box>
  );
};

export default ShortLink;
